import moment from 'moment';
import { DaySchedule, Shift } from 'types/interfaces';

import { generateGUID } from './generateGUID';

export const shiftToDaySchedule = (shift: Shift): DaySchedule => {
  // 1. Собираем локальную дату-время
  const localDateTime = moment(`${shift.date}T${shift.workdayStart}:00`);
  // 2. Переводим в UTC (если просто .toISOString(), то будет с Z)
  const startUtc = localDateTime.utc().format('YYYY-MM-DDTHH:mm:ss');
  const [h, m] = shift.workdayDuration.split(':').map(Number);
  const endUtc = localDateTime
    .clone()
    .add({ hours: h, minutes: m })
    .utc()
    .format('YYYY-MM-DDTHH:mm:ss');

  return {
    id: shift.id,
    start: startUtc,
    end: endUtc,
    departmentId: shift.departmentId,
    workdayStart: shift.workdayStart,
    workdayDuration: shift.workdayDuration,
    break: shift.breakDuration,
    isTemplate: shift.isTemplate ?? false,
    guid: shift.guid || generateGUID()
  };
};
